import { TOGGLE_PODCAST_SETTINGS_LOADING } from "constants/actionTypes"

export const togglePodcastSettingsLoading = loading => ({
	type: TOGGLE_PODCAST_SETTINGS_LOADING,
	payload: loading
})
